/** Kannada: mentors for people new to a city. */
export const mentor = {
    "mentor.city.bengaluru": "ಬೆಂಗಳೂರು",
    "mentor.offer_about": "ಹೊಸಬರು ನಿಮ್ಮ ಮೊದಲ ಹೆಸರು, ಕೆಲಸ, ಭಾಷೆಗಳು, ಪ್ರದೇಶ ಮತ್ತು ನೀವೇ ಎಣಿಸಿದ ಕೆಲಸಗಳನ್ನು ನೋಡುತ್ತಾರೆ. ನಿಮ್ಮ ಫೋನ್ ನಂಬರ್ ಎಂದೂ ಇಲ್ಲ.",
    "mentor.listed": "{city}ನ ಹೊಸಬರು ನಿಮ್ಮನ್ನು ಹುಡುಕಬಹುದು.",
    "mentor.find": "ಮಾರ್ಗದರ್ಶಕರನ್ನು ಹುಡುಕಿ",
    "mentor.find_about": "ಸ್ವಲ್ಪ ಕಾಲದಿಂದ {city}ನಲ್ಲಿ ಕೆಲಸ ಮಾಡುತ್ತಿರುವ, ನಿಮಗೆ ದಾರಿ ತೋರಿಸಬಲ್ಲವರು. ಯಾರನ್ನು ಕೇಳಬೇಕೆಂದು ನೀವೇ ಆರಿಸುತ್ತೀರಿ. ನಿಮ್ಮ ಪರವಾಗಿ ಬೇರೆ ಯಾರೂ ಆರಿಸುವುದಿಲ್ಲ.",
    "mentor.safety_title": "ಯಾರನ್ನಾದರೂ ಭೇಟಿಯಾಗುವ ಮೊದಲು",
    "mentor.safety_public": "ಸಾರ್ವಜನಿಕ ಸ್ಥಳದಲ್ಲಿ ಭೇಟಿಯಾಗಿ.",
    "mentor.safety_money": "ಮಾರ್ಗದರ್ಶಕರ ಮೂಲಕ ಕೆಲಸಕ್ಕಾಗಿ ಅಥವಾ ಕೋಣೆಗಾಗಿ ಯಾರಿಗೂ ಹಣ ಕೊಡಬೇಡಿ.",
    "mentor.safety_report": "ಹಣ ಅಥವಾ ದಾಖಲೆ ಕೇಳುವವರ ಬಗ್ಗೆ ವರದಿ ಮಾಡಿ.",
    "mentor.safety_ok": "ನನಗೆ ಅರ್ಥವಾಯಿತು",
    "mentor.woman_ask": "ನೀವು ಮಹಿಳೆಯೇ? ಇದು ನಿಮ್ಮ ಫೋನ್‌ನಲ್ಲೇ ಇರುತ್ತದೆ. ಮಹಿಳಾ ಮಾರ್ಗದರ್ಶಕರನ್ನು ಮಾತ್ರ ಆರಿಸಲು ಇದು ಸಹಾಯ ಮಾಡುತ್ತದೆ.",
    "mentor.yes": "ಹೌದು",
    "mentor.no": "ಇಲ್ಲ",
    "mentor.women_only": "ಮಹಿಳಾ ಮಾರ್ಗದರ್ಶಕರು ಮಾತ್ರ",
    "mentor.trade": "ಕೆಲಸ",
    "mentor.lang": "ಭಾಷೆ",
    "mentor.search": "ಮಾರ್ಗದರ್ಶಕರನ್ನು ತೋರಿಸಿ",
    "mentor.says": "{months} ತಿಂಗಳಲ್ಲಿ {jobs} ಕೆಲಸ ಎನ್ನುತ್ತಾರೆ",
    "mentor.own_count": "ಇದು ಅವರ ಸ್ವಂತ ಫೋನ್‌ನ ಎಣಿಕೆ.",
    "mentor.vouched": "{name} ಭರವಸೆ ನೀಡಿದೆ",
    "mentor.choose": "{name} ಅವರನ್ನು ಆರಿಸಿ",
    "mentor.chosen": "ಆರಿಸಲಾಗಿದೆ",
    "mentor.max": "ಒಮ್ಮೆಗೆ {count} ಜನರನ್ನು ಕೇಳಬಹುದು.",
    "mentor.none": "ಇನ್ನೂ ಮಾರ್ಗದರ್ಶಕರಿಲ್ಲ",
    "mentor.none_women": "{city}ನಲ್ಲಿ ಇನ್ನೂ ಮಹಿಳಾ ಮಾರ್ಗದರ್ಶಕರಿಲ್ಲ. “ಮಹಿಳಾ ಮಾರ್ಗದರ್ಶಕರು ಮಾತ್ರ” ಆಫ್ ಮಾಡಬಹುದು.",
    "mentor.none_intro": "ನಿಮಗೆ ಗೊತ್ತಿರುವವರನ್ನು — ನೀವು ಕೆಲಸ ಮಾಡಿದ ಮನೆಯವರನ್ನು, ಅಥವಾ ನಿಮ್ಮ ಮಾರ್ಗದರ್ಶಕರನ್ನು — {city}ನಲ್ಲಿ ಯಾರಾದರೂ ಗೊತ್ತೇ ಎಂದು ಕೇಳಿ.",
    "mentor.helplines": "ಉಳಿಸಿಕೊಳ್ಳಬೇಕಾದ ನಂಬರ್‌ಗಳು",
    "mentor.ask.one": "{count} ಮಾರ್ಗದರ್ಶಕರನ್ನು ಕೇಳಿ",
    "mentor.ask.other": "{count} ಮಾರ್ಗದರ್ಶಕರನ್ನು ಕೇಳಿ",
    "mentor.arrival": "ನೀವು ತಲುಪುವ ವಾರ",
    "mentor.area_near": "ಯಾವ ಪ್ರದೇಶದ ಹತ್ತಿರ ಇರುತ್ತೀರಿ (ಗೊತ್ತಿದ್ದರೆ)",
    "mentor.note": "ಚಿಕ್ಕ ಸಂದೇಶ (ಬೇಕಿದ್ದರೆ)",
    "mentor.send": "ಕಳುಹಿಸಿ",
    "mentor.sent": "ಕೇಳಲಾಗಿದೆ. ಅವರ ಉತ್ತರಗಳು ಇಲ್ಲಿ ಕಾಣುತ್ತವೆ.",
    "mentor.too_old": "{name} ಮೊದಲು GigSync ಅಪ್‌ಡೇಟ್ ಮಾಡಬೇಕು.",
    "mentor.offers": "ನಿಮಗೆ ಸಹಾಯ ಮಾಡಬಲ್ಲ ಮಾರ್ಗದರ್ಶಕರು",
    "mentor.your_requests": "ನಿಮ್ಮ ವಿನಂತಿಗಳು",
    "mentor.waiting": "{name} ಅವರಿಗಾಗಿ ಕಾಯುತ್ತಿದೆ…",
    "mentor.declined": "{name} ಈಗ ಸಹಾಯ ಮಾಡಲು ಆಗುವುದಿಲ್ಲ.",
    "mentor.closed": "ಮುಚ್ಚಲಾಗಿದೆ",
    "mentor.offered": "{name} ನಿಮಗೆ ಸಹಾಯ ಮಾಡಬಲ್ಲರು.",
    "mentor.accept_offer": "{name} ಅವರನ್ನು ಒಪ್ಪಿ",
    "mentor.accept_help": "ನಂತರ 30 ದಿನ ಪರಸ್ಪರ ಸಂದೇಶ ಕಳುಹಿಸಬಹುದು. ಯಾರಾದರೂ ಇದನ್ನು ವಿಸ್ತರಿಸಬಹುದು.",
    "mentor.cancel": "ರದ್ದುಮಾಡಿ",
    "mentor.linked": "ಈಗ ನೀವು ಮತ್ತು {name} 30 ದಿನ ಪರಸ್ಪರ ಸಂದೇಶ ಕಳುಹಿಸಬಹುದು.",
    "mentor.requests": "ಸಹಾಯ ಕೇಳುತ್ತಿರುವ ಹೊಸಬರು",
    "mentor.request_line": "{name} {trade} ಕೆಲಸಕ್ಕಾಗಿ {city}ಗೆ ಬರುತ್ತಿದ್ದಾರೆ, {date} ವಾರದಲ್ಲಿ ತಲುಪುತ್ತಾರೆ.",
    "mentor.request_near": "{area} ಹತ್ತಿರ ಇರುತ್ತಾರೆ.",
    "mentor.speaks": "ಭಾಷೆ: {langs}",
    "mentor.help": "{name} ಅವರಿಗೆ ಸಹಾಯ ಮಾಡಿ",
    "mentor.not_now": "ಈಗ ಬೇಡ",
    "mentor.offer_note": "ಅವರಿಗೆ ಚಿಕ್ಕ ಸಂದೇಶ (ಬೇಕಿದ್ದರೆ)",
    "mentor.chip": "ಮಾರ್ಗದರ್ಶಕ",
    "mentor.chip_newcomer": "ನಗರಕ್ಕೆ ಹೊಸಬರು",
    "mentor.days_left.one": "{count} ದಿನ ಉಳಿದಿದೆ",
    "mentor.days_left.other": "{count} ದಿನ ಉಳಿದಿವೆ",
    "mentor.renew": "ಇನ್ನೂ 30 ದಿನ ವಿಸ್ತರಿಸಿ",
    "mentor.renewed": "ಇನ್ನೂ 30 ದಿನ ತೆರೆದಿದೆ.",
    "mentor.block": "ಬ್ಲಾಕ್ ಮಾಡಿ",
    "mentor.block_confirm": "{name} ಅವರನ್ನು ಬ್ಲಾಕ್ ಮಾಡಬೇಕೇ? ಈ ಫೋನ್‌ನಲ್ಲಿ ಅವರು ಎಲ್ಲೂ ಕಾಣುವುದಿಲ್ಲ, ಮತ್ತು GigSync ನಿಮ್ಮನ್ನು ಮತ್ತೆ ಜೋಡಿಸುವುದಿಲ್ಲ.",
    "mentor.blocked": "{name} ಬ್ಲಾಕ್ ಆಗಿದ್ದಾರೆ.",
    "mentor.report": "ವರದಿ ಮಾಡಿ",
    "mentor.report_title": "{name} ಬಗ್ಗೆ ವರದಿ ಮಾಡಿ",
    "mentor.reason.asked_money": "ನನ್ನಿಂದ ಹಣ ಕೇಳಿದರು",
    "mentor.reason.asked_documents": "ನನ್ನ ದಾಖಲೆಗಳನ್ನು ಕೇಳಿದರು",
    "mentor.reason.unsafe": "ನನಗೆ ಅಸುರಕ್ಷಿತ ಅನಿಸಿತು",
    "mentor.reason.rude": "ಅಸಭ್ಯವಾಗಿ ವರ್ತಿಸಿದರು",
    "mentor.reason.other": "ಬೇರೆ ಏನೋ",
    "mentor.report_send": "ವರದಿ ಕಳುಹಿಸಿ",
    "mentor.reported": "ಧನ್ಯವಾದ. GigSync ಇದನ್ನು ಪರಿಶೀಲಿಸುತ್ತದೆ.",
    "mentor.intro_ask": "{city}ನಲ್ಲಿ ನಿಮಗೆ ಯಾರಾದರೂ ಗೊತ್ತೇ?",
    "mentor.intro_ask_note": "ನಾನು {city}ಗೆ ಹೋಗುತ್ತಿದ್ದೇನೆ. ಅಲ್ಲಿ ನನಗೆ ನೆಲೆಯೂರಲು ಸಹಾಯ ಮಾಡಬಲ್ಲ ಯಾರಾದರೂ ನಿಮಗೆ ಗೊತ್ತೇ?",
    "mentor.intro_asked": "ನೀವು {name} ಅವರನ್ನು ಕೇಳಿದ್ದೀರಿ.",
    "mentor.introduce": "{name} ಅವರನ್ನು ಯಾರಿಗಾದರೂ ಪರಿಚಯಿಸಿ",
    "mentor.intro_pick": "{city}ನಲ್ಲಿ {name} ಯಾರನ್ನು ಭೇಟಿಯಾಗಬೇಕು?",
    "mentor.intro_send": "{name} ಅವರನ್ನು ಪರಿಚಯಿಸಿ",
    "mentor.intro_sent": "ನೀವು {name} ಮತ್ತು {other} ಅವರನ್ನು ಪರಿಚಯಿಸಿದ್ದೀರಿ.",
    "mentor.intro_none": "ನೀವು ಕೆಲಸಕ್ಕೆ ಸಹಿ ಮಾಡಿದವರನ್ನು, ಅಥವಾ ಮಾರ್ಗದರ್ಶಕ ಜೋಡಣೆ ಇದ್ದವರನ್ನು ಮಾತ್ರ ಪರಿಚಯಿಸಬಹುದು.",
    "mentor.intro_got_mentor": "{city}ನಲ್ಲಿ ಕೆಲಸ ಮಾಡುವ, ನಿಮಗೆ ಸಹಾಯ ಮಾಡಬಲ್ಲ {name} ಅವರನ್ನು ನೀವು ಭೇಟಿಯಾಗಬೇಕೆಂದು {by} ಬಯಸುತ್ತಾರೆ.",
    "mentor.intro_got_newcomer": "{city}ಗೆ ಬರುತ್ತಿರುವ, ನಿಮ್ಮ ಸಹಾಯ ಬೇಕಾಗಿರುವ {name} ಅವರನ್ನು ನೀವು ಭೇಟಿಯಾಗಬೇಕೆಂದು {by} ಬಯಸುತ್ತಾರೆ.",
    "mentor.intro_meet": "{name} ಅವರನ್ನು ಭೇಟಿಯಾಗಿ",
    "mentor.intro_no": "ಬೇಡ, ಧನ್ಯವಾದ",
    "mentor.intro_waiting": "{name} ಒಪ್ಪಲು ಕಾಯುತ್ತಿದೆ…",
    "mentor.intros": "ಪರಿಚಯಗಳು",
    "mentor.links": "ಮಾರ್ಗದರ್ಶಕ ಜೋಡಣೆಗಳು",
    "mentor.links_about": "ನಿಮ್ಮ ಮಾರ್ಗದರ್ಶಕರು ಮತ್ತು ನೀವು ಸಹಾಯ ಮಾಡುವವರು. ನಿಮ್ಮಲ್ಲಿ ಯಾರಾದರೂ ಮುಂದುವರಿಸದಿದ್ದರೆ ಜೋಡಣೆ 30 ದಿನ ಇರುತ್ತದೆ.",
    "mentor.unread.one": "{count} ಹೊಸ ಸಂದೇಶ",
    "mentor.unread.other": "{count} ಹೊಸ ಸಂದೇಶಗಳು",
    "mentor.placeholder": "{name} ಅವರಿಗೆ ಸಂದೇಶ",
    "mentor.thread_empty": "{name} ಅವರಿಗೆ ನಮಸ್ಕಾರ ಹೇಳಿ.",
    "mentor.end": "ಜೋಡಣೆ ಮುಗಿಸಿ",
    "mentor.end_confirm": "{name} ಅವರೊಂದಿಗಿನ ಜೋಡಣೆ ಮುಗಿಸಲೇ? ಅವರೊಂದಿಗಿನ ಸಂದೇಶಗಳು ಈ ಫೋನ್‌ನಿಂದ ಅಳಿಸಿಹೋಗುತ್ತವೆ.",
    "mentor.ask_person": "{name} ಅವರನ್ನು ಕೇಳಿ",
    "mentor.no_people": "ಇನ್ನೂ ಯಾರೂ ಇಲ್ಲ. ನೀವು ಕೆಲಸಕ್ಕೆ ಸಹಿ ಮಾಡಿದವರು, ಅಥವಾ ಮಾರ್ಗದರ್ಶಕರಾಗಿ ಜೋಡಿಸಿದವರು ಇಲ್ಲಿ ಕಾಣುತ್ತಾರೆ.",
};
//# sourceMappingURL=mentor.js.map